import { Feather } from 'lucide-react';

/** The "toiyp" wordmark above the sign-in, handle and first-run screens. */
export function BrandMark({ tagline = 'letters, slowly' }: { tagline?: string }) {
  return (
    <div className="auth-brand">
      <div className="auth-logo">
        <Feather size={26} />
      </div>
      <h1 className="auth-title brand-wordmark">toiyp</h1>
      <p className="auth-tagline">{tagline}</p>
    </div>
  );
}
